// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Header_wrapper__3mqUo","title":"Header_title__3mFoo","expanded":"Header_expanded__2flrX"};